import React, { useEffect, useState } from "react";

import RadioButtonFormView from "./view";

const RadioButtonForm = ({
  callbackIsChecked,
  isChecked,
  title,
  id,
  getDescription,
  content,
  getTitle,
  type,
  viewPdf,
  handleDelete,
  row,
  item,
  handleSettings,
  size,
  options,
  onMouseEnter,
  onMouseLeave,
  pdf,
  _title,
  _description,
  highlightItem,
}) => {
  const [show, setShow] = useState(pdf === true ? true : false);
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    setHighlight(highlightItem);
  }, [highlightItem]);

  const changeChecked = (event) => {
    callbackIsChecked(event.target.checked);
  };

  const onChangeTitle = (e) => {
    getTitle(e.target.value, id);
  };

  const onChangeDescription = (e) => {
    getDescription(e.target.value, id);
  };

  const onChangeViewPdf = () => {
    setShow(!show);
    viewPdf(show, id);
  };

  const onChangeDelete = () => {
    handleDelete(id);
  };

  const onChangeSettings = () => {
    handleSettings(id, options);
  };
  const onMouseEnterEvent = () => {
    onMouseEnter(id, true);
    setHighlight(true);
  };

  const onMouseLeaveEvent = () => {
    onMouseLeave(id, false);
    setHighlight(false);
  };

  return (
    <div
      className={highlight === true && "highlighted"}
      onMouseEnter={onMouseEnterEvent}
      onMouseLeave={onMouseLeaveEvent}
    >
      <RadioButtonFormView
        changeChecked={changeChecked}
        isChecked={isChecked}
        title={title}
        size={size}
        item={item}
        row={row}
        type={type}
        options={options}
        onChangeTitle={onChangeTitle}
        onChangeDescription={onChangeDescription}
        onChangeDelete={onChangeDelete}
        onChangeViewPdf={onChangeViewPdf}
        onChangeSettings={onChangeSettings}
        viewPdf={show}
        disabled={true}
        _title={_title}
        _description={_description}
      />
    </div>
  );
};

export default RadioButtonForm;
